import { render, staticRenderFns } from "./MarketplacePricingModal.vue?vue&type=template&id=8f9934c4&scoped=true"
import script from "./MarketplacePricingModal.vue?vue&type=script&lang=js"
export * from "./MarketplacePricingModal.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePricingModal.vue?vue&type=style&index=0&id=8f9934c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9934c4",
  null
  
)

export default component.exports